<div [ngSwitch]="invoice.accountingStatus">
  <span class="badge badge-success" *ngSwitchCase="'CREATED'">
    Facture créée
  </span>
  <span class="badge badge-primary" *ngSwitchCase="'FOUND_EXISTING'">Facture existante</span>
  <span class="badge badge-danger" *ngSwitchDefault>Facture manquante</span>
</div>
<div *ngIf="quickbookUrl != undefined && invoice.quickbookBillId != undefined">
  <a [attr.href]="quickbookUrl + '/bill?txnId=' + invoice.quickbookBillId" target="_blank">Fiche Quickbook</a>
</div>

<div *ngIf="invoice.accountingStatusTimestamp">
  Mise à jour le <strong>{{ invoice.accountingStatusTimestamp | date: 'medium' }}</strong>
</div>